import React from 'react';
import { Item } from 'semantic-ui-react';
import { Link } from 'react-router-dom';
import _ from 'underscore';

const HealthArticlesList = (props) => {
    return (
        <Item.Group divided>
            {
                _.map(props.articles, (article) => {
                    const {
                        uuid,
                        imageURL,
                        excerpt
                    } = article;
                    return (
                        <Item key={uuid}>
                            <Item.Image src={imageURL} />
                            <Item.Content>
                                <Item.Header>
                                    <Link to={`/app/healtharticles/view?type=1&id=${uuid}`}>
                                        {excerpt}
                                    </Link>
                                </Item.Header>
                            </Item.Content>
                        </Item>
                    );
                })
            }
        </Item.Group>
    );
}

export default HealthArticlesList;